import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Stack,
  Button,
  CircularProgress
} from '@mui/material';

const PublishCard = ({
  checklist = [],
  status,
  loading,
  canPublish,
  handleUnpublish,
  handleSave,
  setModalOpen,
  isEdit,
  navigate
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #E2E8F0',
        borderRadius: '8px',
        p: '14px 16px',
        mb: 1.75,
        boxShadow: 'none'
      }}
    >
      <Typography variant="subtitle1" sx={{ fontSize: 13.5, fontWeight: 600, color: '#1E293B', mb: 0.75, display: 'flex', alignItems: 'center' }}>
        Publish{' '}
        <Box component="span" sx={{ backgroundColor: '#803927', color: '#fff', fontSize: 9.5, px: '5px', py: '1px', borderRadius: '4px', fontWeight: 600, ml: 0.75 }}>
          NEW
        </Box>
      </Typography>

      <Stack spacing={0.6} sx={{ mb: 1.5 }}>
        {checklist.map((c, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 12 }}>
            <Typography
              component="span"
              sx={{ fontWeight: 600, color: c.valid ? '#2E7D32' : '#DC2626', width: 14 }}
            >
              {c.valid ? '✓' : '✕'}
            </Typography>
            <Typography component="span" sx={{ color: '#334155', fontSize: 12 }}>
              {c.label}
            </Typography>
          </Box>
        ))}
      </Stack>

      {status === 'Published' ? (
        <Button
          fullWidth
          variant="contained"
          disabled={loading}
          disableElevation disableRipple
          onClick={handleUnpublish}
          sx={{
            backgroundColor: '#FFBD65',
            color: '#1E293B',
            py: 1,
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: 13,
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': { backgroundColor: '#F5A947', boxShadow: 'none' }
          }}
        >
          {loading ? <CircularProgress size={18} sx={{ color: '#1E293B' }} /> : 'Unpublish'}
        </Button>
      ) : (
        <Button
          fullWidth
          variant="contained"
          disabled={!canPublish || loading}
          disableElevation disableRipple
          onClick={() => handleSave('Published')}
          sx={{
            backgroundColor: '#FFBD65',
            color: '#1E293B',
            py: 1,
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: 13,
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': { backgroundColor: '#F5A947', boxShadow: 'none' },
            '&:disabled': { backgroundColor: '#F1F5F9', color: '#94A3B8' }
          }}
        >
          {loading ? <CircularProgress size={18} sx={{ color: '#1E293B' }} /> : 'Publish Hub Page'}
        </Button>
      )}

      <Button
        fullWidth
        variant="outlined"
        disableElevation disableRipple
        onClick={() => setModalOpen(true)}
        sx={{
          mt: 1,
          backgroundColor: '#FFFFFF',
          borderColor: '#E2E8F0',
          color: '#334155',
          py: 0.9,
          borderRadius: '6px',
          fontWeight: 500,
          fontSize: 13,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': { backgroundColor: '#F8FAFC', borderColor: '#CBD5E1', boxShadow: 'none' }
        }}
      >
        Preview page
      </Button>

      <Button
        fullWidth
        variant="outlined"
        disabled={loading}
        disableElevation disableRipple
        onClick={() => handleSave('Draft')}
        sx={{
          mt: 1,
          backgroundColor: '#FFFFFF',
          borderColor: '#E2E8F0',
          color: '#334155',
          py: 0.9,
          borderRadius: '6px',
          fontWeight: 500,
          fontSize: 13,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': { backgroundColor: '#F8FAFC', borderColor: '#CBD5E1', boxShadow: 'none' }
        }}
      >
        {isEdit ? 'Update Draft' : 'Save Draft'}
      </Button>

      {isEdit && (
        <Button
          fullWidth
          variant="contained"
          disabled={loading}
          disableElevation disableRipple
          onClick={() => handleSave(status === 'Published' ? 'Published' : 'Draft')}
          sx={{
            mt: 1,
            backgroundColor: '#6E8964',
            color: '#FFFFFF',
            py: 0.9,
            borderRadius: '6px',
            fontWeight: 500,
            fontSize: 13,
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': { backgroundColor: '#5A7352', boxShadow: 'none' },
            '&:disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' }
          }}
        >
          {loading ? <CircularProgress size={18} sx={{ color: '#FFFFFF' }} /> : 'Update Hub'}
        </Button>
      )}

      <Button
        fullWidth
        variant="text"
        disableRipple
        onClick={() => navigate('/hubs-locations')}
        sx={{
          mt: 1,
          color: '#64748B',
          fontSize: 13,
          textTransform: 'none',
          '&:hover': { backgroundColor: 'transparent', color: '#1E293B' }
        }}
      >
        Cancel
      </Button>

      <Paper
        elevation={0}
        sx={{
          backgroundColor: '#F8FAFC',
          border: '1px solid #E2E8F0',
          borderRadius: '6px',
          p: '8px 10px',
          fontSize: 11,
          color: '#475569',
          mt: 1.25,
          lineHeight: 1.45
        }}
      >
        Page is rendered as static HTML (ISR). It re-renders every time you publish and once a day on its own, so new retreats appear without anyone touching the page.
      </Paper>
    </Paper>
  );
};

export default React.memo(PublishCard);
